import React, { useId } from 'react';
import { Box } from '@mui/material';
import { AU, ANILLO_FOCO, BORDE_AZUL, ESTADO_ERROR, FUENTE, RADIO_CAMPO } from '../../styles/tokensAU';

// Campo de texto al estilo de la app: etiqueta arriba, caja de 48 px, ayuda y error debajo.
// Sin `required` nativo (las burbujas del navegador se ven mal): la página valida y usa `error`.
const CampoAU = ({
  etiqueta,
  name,
  value,
  onChange,
  tipo = 'text',
  ayuda,
  error,
  soloLectura = false,
  requerido = false,
  sufijo,
  autoComplete,
  inputMode,
}) => {
  const id = useId();
  const idAyuda = `${id}-ayuda`;
  const idError = `${id}-error`;
  const describedBy = [ayuda && idAyuda, error && idError].filter(Boolean).join(' ') || undefined;

  return (
    <Box>
      <Box
        component="label"
        htmlFor={id}
        sx={{ display: 'block', fontFamily: FUENTE, fontSize: 13, fontWeight: 600, color: AU.oscuro, mb: 0.75 }}
      >
        {etiqueta}
        {requerido && (
          <Box component="span" aria-hidden="true" sx={{ color: AU.azulHover }}>{' *'}</Box>
        )}
      </Box>
      <Box sx={{ position: 'relative' }}>
        <Box
          component="input"
          id={id}
          name={name}
          type={tipo}
          value={value}
          onChange={onChange}
          readOnly={soloLectura}
          aria-required={requerido || undefined}
          aria-invalid={error ? true : undefined}
          aria-describedby={describedBy}
          autoComplete={autoComplete}
          inputMode={inputMode}
          sx={{
            width: '100%',
            boxSizing: 'border-box',
            minHeight: 48,
            px: 1.75,
            pr: sufijo ? 5 : 1.75,
            borderRadius: RADIO_CAMPO,
            border: `1px solid ${error ? ESTADO_ERROR.borde : BORDE_AZUL}`,
            bgcolor: soloLectura ? AU.grisClaro : AU.blanco,
            color: AU.oscuro,
            fontFamily: FUENTE,
            fontSize: 16, // 16 px: iOS no hace zoom al enfocar
            // El indicador de foco es el borde azul (o rojo con error) más el anillo. El contorno transparente
            // es invisible en modo normal y en forced-colors (alto contraste de Windows) el navegador lo pinta.
            outline: '2px solid transparent',
            '&:focus': { borderColor: error ? ESTADO_ERROR.texto : AU.azul, boxShadow: ANILLO_FOCO },
            '&::-webkit-calendar-picker-indicator': soloLectura ? { display: 'none' } : {},
          }}
        />
        {sufijo && (
          <Box sx={{ position: 'absolute', right: 14, top: '50%', transform: 'translateY(-50%)', color: AU.azulHover, display: 'flex' }}>
            {sufijo}
          </Box>
        )}
      </Box>
      {ayuda && (
        <Box id={idAyuda} sx={{ mt: 0.75, fontFamily: FUENTE, fontSize: 12, color: AU.oscuro }}>{ayuda}</Box>
      )}
      {error && (
        <Box id={idError} role="alert" sx={{ mt: 0.75, fontFamily: FUENTE, fontSize: 12, color: ESTADO_ERROR.texto }}>{error}</Box>
      )}
    </Box>
  );
};

export default CampoAU;
